import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { VMediumDutiesFormTypeComboBoxModel } from '../vmedium-duties-form-type-combo-box.model';

/**
 * 業態別媒体区分リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetVMediumDutiesListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetVMediumDutiesListService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: VMediumDutiesFormTypeComboBoxModel;
  private orderCode: string = null;
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetVMediumDutiesListService
   */
  private getBody(): PlessRequest {
    return new  PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {VMediumDutiesFormTypeComboBoxModel} model
   * @param {string} orderCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetVMediumDutiesListService
   */
  execute(model: VMediumDutiesFormTypeComboBoxModel, orderCode: string, successFunc: () => void = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.successFunc = successFunc;
    this.send('KYMW02getVMediumDutiesFormList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: any) {
    this.model.updateMediumList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
